import React from 'react'
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.min.css';
import PatientInfo from '../components/PatientInfo'
import DocumentSubmission from '../components/DocumentSubmission'

export default function SubmitDocument() {
  return (
    <div className="container" id="content">
      <div id="container" className="upload-content">
        <div id="hcp_post_content">
          <h1 style={{ fontSize: '1.5em', lineHeight: '1.49em' }}>Upload Document</h1>
          <PatientInfo />
          <DocumentSubmission cancel='profile' uploadSource='PATIENT' />
          <p className="clearfloat"></p>
        </div>
      </div>
    </div>
  )
}

